import { Stack, Typography } from "@mui/material";
import { useState } from "react";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import { investorCommunicationTypeIcons } from "../../investorCommunicationTypeIcons";
import InvestorCommunicationContext from "../InvestorCommunicationContext";
import InvestorCommunicationContentPreviewDialog from "../content/InvestorCommunicationContentPreviewDialog";
import InvestorCommunicationPreviewImage from "../content/InvestorCommunicationPreviewImage";
import InvestorCommunicationSavedContentPreview from "../content/InvestorCommunicationSavedContentPreview";
import InvestorCommunicationSettingsTile from "./InvestorCommunicationSettingsTile";

const InvestorCommunicationContentTile = () => {
  const { investorCommunication, savedHeroImageSource, savedThumbnailSource, hasEditPermissions, onTabChange } =
    useDefinedContext(InvestorCommunicationContext, "InvestorCommunicationContext");

  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  const { type, content, videoContent } = investorCommunication;
  const isVideo = type === "Video";
  const isViewDisabled = isVideo && videoContent?.videoFileId === undefined;

  return (
    <InvestorCommunicationSettingsTile
      title="Content"
      Icon={investorCommunicationTypeIcons[type]}
      onView={isViewDisabled ? undefined : () => setIsPreviewOpen(true)}
      onEdit={hasEditPermissions ? () => onTabChange("content") : undefined}
    >
      <Stack direction="row" spacing={2}>
        <InvestorCommunicationPreviewImage type={type} source={isVideo ? savedThumbnailSource : savedHeroImageSource} />
        <Stack spacing={1}>
          <Typography variant="subtitle1">{content?.title || "Untitled"}</Typography>
          {content?.description && <Typography color="textSecondary">{content.description}</Typography>}
        </Stack>
      </Stack>

      {isPreviewOpen && (
        <InvestorCommunicationContentPreviewDialog onClose={() => setIsPreviewOpen(false)}>
          <InvestorCommunicationSavedContentPreview />
        </InvestorCommunicationContentPreviewDialog>
      )}
    </InvestorCommunicationSettingsTile>
  );
};

export default InvestorCommunicationContentTile;
